import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import OccurrencesCode8ViewContent from 'component/report/occurrencescode8/OccurrencesCode8ViewContent'

class OccurrencesCode8Modal extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    icon: PropTypes.string.isRequired,
    titleText: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    valueComplement: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    titleList: PropTypes.string.isRequired,
    listSections: PropTypes.array.isRequired,
    typeContent: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      size: 'sm',
    }

    this.renderContent = this.renderContent.bind(this)
  }

  componentWillMount() {}

  renderContent(props) {
    const newProps = {
      ...props,
    }

    return <OccurrencesCode8ViewContent {...newProps} />
  }

  render() {
    const { size } = this.state

    return (
      <Modal closeModal={this.props.closeModal} size={size}>
        {this.renderContent(this.props)}
      </Modal>
    )
  }
}

export default OccurrencesCode8Modal
